import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const CutChickenContext = createContext();

export const CutChickenProvider = ({ children }) => {
  // const [getData, setGetData] = useState(true)

  const [infoCutChicken, setInfoCutChicken] = useState({
    previsaoVendas: 0,
    estoque: 0,
    previsaoProducao: 0,
    custoUnitario: 0,
    receitaProduto: 0,
    pesoCaixa: 1,
    preco: 8.50
  });

  const [insumosCutChicken, setInsumosCutChicken] = useState([])
  const [stockCutChickenMarket, setStockCutChickenMarket] = useState(0)

  function getCutChickenStockMp() {

    const storagedCurrentUserGame = JSON.parse(localStorage.getItem('@App:currentUserGame'));

    if (!storagedCurrentUserGame?.supermercado) return

    axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/estoque/obterEstoqueSuperMercado/9/${storagedCurrentUserGame?.supermercado}`)
      .then(response => {
        setStockCutChickenMarket(response.data ? response.data.quantidade : 0)
      })

  }

  function getCutChickenStock() {

    const storagedIndustry = JSON.parse(localStorage.getItem('@App:industria'));
    if (!storagedIndustry) return
    axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/estoque/obterEstoqueIndustria/9/${storagedIndustry?.industria}`)
      .then(response => {
        setInfoCutChicken({
          previsaoVendas: 0,
          estoque: response.data ? response.data.quantidade : 0,
          previsaoProducao: 0,
          custoUnitario: infoCutChicken.custo,
          receitaProduto: infoCutChicken.receitaProduto,
          pesoCaixa: 1,
          preco: 8.50
        })
      })

  }

  useEffect(() => {
    const storagedJogo = JSON.parse(localStorage.getItem('@App:jogo'));

    axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/produto/listarInsumos/9`)
      .then(response => {
        console.log(response)
        setInsumosCutChicken(response.data)

      })

    axios.get("https://sistemas.sisinfor.com.br/BusinessGameBack/api/produto/listarTodos")
      .then(response => {
        const data = response.data[2]
        const storagedIndustry = JSON.parse(localStorage.getItem('@App:industria'));
        const storagedCurrentUserGame = JSON.parse(localStorage.getItem('@App:currentUserGame'));

        if (storagedCurrentUserGame?.supermercado) {
          //get do estoque do supermercado
          axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/estoque/obterEstoqueSuperMercado/9/${storagedCurrentUserGame?.supermercado}`)
            .then(response => {
              setStockCutChickenMarket(response.data ? response.data.quantidade : 0)
              setInfoCutChicken({
                custoUnitario: data.custo
              })
            })
        }

        if (!storagedIndustry) return
        axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/estoque/obterEstoqueIndustria/9/${storagedIndustry?.industria}`)
          .then(response => {

            setInfoCutChicken({
              previsaoVendas: 0,
              estoque: response.data ? response.data.quantidade : 0,
              previsaoProducao: 0,
              custoUnitario: data.custo,
              receitaProduto: infoCutChicken.receitaProduto,
              pesoCaixa: 1,
              preco: 8.50
            })

          })

      })


  }, []);
  return (
    <CutChickenContext.Provider
      value={{
        infoCutChicken,
        setInfoCutChicken,
        setInsumosCutChicken,
        insumosCutChicken,
        getCutChickenStockMp,
        stockCutChickenMarket,
        getCutChickenStock
      }}
    >
      {children}
    </CutChickenContext.Provider>
  );
};

export const useCutChicken = () => useContext(CutChickenContext);
